import React, { useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import './FeaturedTestimonial.css';

// Picks the featured testimonial video. Swap path here to change.
const VIDEO_SRC = '/assets/testimonials/testimonial-v81.mp4';

const FeaturedTestimonial = () => {
  const videoRef = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [muted, setMuted] = useState(true);

  const togglePlay = () => {
    const v = videoRef.current;
    if (!v) return;
    if (v.paused) {
      v.play().catch(() => {});
      setPlaying(true);
    } else {
      v.pause();
      setPlaying(false);
    }
  };

  const toggleMute = (e) => {
    e.stopPropagation();
    const v = videoRef.current;
    if (!v) return;
    v.muted = !v.muted;
    setMuted(v.muted);
  };

  return (
    <section className="featured-testimonial">
      <div className="container">
        <div className="featured-testimonial__grid">
          {/* LEFT — text */}
          <div className="featured-testimonial__text">
            <p className="section-label" style={{ textAlign: 'left' }}>
              In their own words
            </p>
            <h2 className="featured-testimonial__title">
              Care that helped.
              <br />
              Outcomes that stayed.
            </h2>
            <p className="featured-testimonial__lead">
              Real stories from people who walked into Mind Spa carrying something
              heavy &mdash; and found a way through. Watch what therapy looks like,
              in their own words.
            </p>
            <div className="featured-testimonial__actions">
              <Link to="/testimonials" className="btn-primary">
                Watch more stories
              </Link>
              <Link to="/contact" className="featured-testimonial__link">
                Begin your own &rarr;
              </Link>
            </div>
          </div>

          {/* RIGHT — video card */}
          <div
            className={`featured-testimonial__video-card ${playing ? 'is-playing' : ''}`}
            onClick={togglePlay}
            role="button"
            aria-label={playing ? 'Pause testimonial video' : 'Play testimonial video'}
            tabIndex={0}
            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); togglePlay(); } }}
          >
            <video
              ref={videoRef}
              src={VIDEO_SRC}
              muted={muted}
              playsInline
              preload="metadata"
              className="featured-testimonial__video"
              onPlay={() => setPlaying(true)}
              onPause={() => setPlaying(false)}
              onEnded={() => setPlaying(false)}
            />

            {!playing && (
              <div className="featured-testimonial__overlay">
                <div className="featured-testimonial__quote">
                  &ldquo;Therapy helped me reclaim my life.&rdquo;
                  <span className="featured-testimonial__attribution">
                    Client at Mind Spa
                  </span>
                </div>
                <button
                  type="button"
                  className="featured-testimonial__play"
                  aria-label="Play video"
                  onClick={(e) => { e.stopPropagation(); togglePlay(); }}
                >
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor">
                    <polygon points="6 4 20 12 6 20" />
                  </svg>
                </button>
              </div>
            )}

            {playing && (
              <button
                type="button"
                className="featured-testimonial__mute"
                onClick={toggleMute}
                aria-label={muted ? 'Unmute' : 'Mute'}
              >
                {muted ? (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" fill="currentColor"/>
                    <line x1="23" y1="9" x2="17" y2="15"/>
                    <line x1="17" y1="9" x2="23" y2="15"/>
                  </svg>
                ) : (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5" fill="currentColor"/>
                    <path d="M19.07 4.93a10 10 0 010 14.14M15.54 8.46a5 5 0 010 7.07"/>
                  </svg>
                )}
              </button>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturedTestimonial;
